import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/**
 * Growth in the web app: the client's affiliate page, reports, affiliates and mass mail for staff,
 * and the dashboard figures (income, what needs attention).
 */
const reports = () => import('./reports.jsx');
const affiliates = () => import('./affiliates.jsx');
const massmail = () => import('./massmail.jsx');
const schedules = () => import('./schedules.jsx');
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const later = (load, name) => {
  const C = lazy(() => load().then((m) => ({ default: m[name] })));
  return function Lazy(props) {
    return (
      <Suspense fallback={<Loading />}>
        <C {...props} />
      </Suspense>
    );
  };
};

export default {
  name: 'growth',
  publicRoutes: [{ path: 'unsubscribed', lazy: page(massmail, 'Unsubscribed') }],
  clientRoutes: [{ path: 'affiliate', lazy: page(affiliates, 'ClientAffiliate') }],
  adminRoutes: [
    { path: 'reports', lazy: page(reports, 'ReportsIndex') },
    { path: 'reports/schedules', lazy: page(schedules, 'ReportSchedules') },
    { path: 'reports/:report', lazy: page(reports, 'Report') },
    { path: 'affiliates', lazy: page(affiliates, 'AdminAffiliates') },
    { path: 'affiliates/:uuid', lazy: page(affiliates, 'AdminAffiliate') },
    { path: 'mass-mail', lazy: page(massmail, 'MassMail') },
  ],
  clientNav: [{ key: 'affiliates', to: '/affiliate', label: 'Affiliates', order: 60, auth: true }],
  adminNav: [
    { section: 'reports', to: '/admin/reports', label: 'Reports', permission: 'admin.reports.read', order: 10 },
    {
      section: 'clients',
      to: '/admin/affiliates',
      label: 'Affiliates',
      permission: 'admin.affiliates.read',
      order: 50,
    },
    { section: 'clients', to: '/admin/mass-mail', label: 'Mass mail', permission: 'admin.email.mass', order: 60 },
  ],
  adminWidgets: [
    {
      key: 'income',
      order: 10,
      permission: 'admin.reports.read',
      Component: later(reports, 'IncomeWidget'),
      wide: true,
    },
    {
      key: 'attention',
      order: 20,
      permission: 'admin.reports.read',
      Component: later(reports, 'OperationsWidget'),
      wide: true,
    },
  ],
};
